import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
function VehicleTypeDetails({t}) {
  const navigate = useNavigate();
  const location = useLocation();
  const vehicleTypeDetails = location.state?.vehicleTypeDetails || {};

  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row text-end">
                <div className="col">
                  <button
                    type="button"
                    class="btn btn-danger"
                    style={{
                      backgroundColor: "rgb(236, 17, 23)",
                    }}
                    onClick={() => navigate("/vehicle-type")}
                  >
                    {t("back")}
                  </button>
                </div>
              </div>
              <h4 style={{ display: "flex", marginBottom: "30px" }}>
                Vehicle Type Details of : {vehicleTypeDetails.name}
              </h4>
              <div className="card">
                <div className="p-3">
                  <div className="text-start mb-3">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t("vehicleTypeName")}</label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            readOnly
                            value={vehicleTypeDetails.name}
                          />
                        </div>
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t("status")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="status"
                            readOnly
                            value={
                              vehicleTypeDetails.status === "1"
                                ? "Active"
                                : "Inactive"
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(VehicleTypeDetails);
